const routes = {
  // home: "/",
  programs: "/programs",
  login: "/login",
  forgotPassword: "/forgotPassword",
  ResetPassword: "/resetPassword/:id/:token",
  ConfirmEmail: "/confirmEmail/:id/:token",
  personalAccount: "/personalAccount",
  myBalance: "/myBalance",
  syncOrder: "/sync/:order_number",
  register: "/register",
  MyVehicles: "/myVehicles",
  MyFriends: "/myFriends",
  MyPartners: "/myPartners",
  profile: "/profile",
  StationsMap: "/stationsMap",
  Transactions: "/transactions",
};
export default routes;
